import { render, staticRenderFns } from "./FichaTecnicaPanel.vue?vue&type=template&id=28d83ab8&scoped=true&lang=pug&"
import script from "./FichaTecnicaPanel.vue?vue&type=script&lang=js&"
export * from "./FichaTecnicaPanel.vue?vue&type=script&lang=js&"
import style0 from "./FichaTecnicaPanel.vue?vue&type=style&index=0&id=28d83ab8&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d83ab8",
  null
  
)

export default component.exports